module.exports = __webpack_public_path__ + "media/images/lps-graph-default-b6a2dcc2.png";